/* eslint-disable react/button-has-type */
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/16/solid";
import { DateTime } from "luxon";
import { NavProps } from "react-day-picker";
interface CustomNavProps extends NavProps {
  currentMonth: Date;
  className?: string;
}

const CustomNav = ({
  onPreviousClick,
  onNextClick,
  previousMonth,
  nextMonth,
  currentMonth,
  className="",
}: CustomNavProps) => {
  return (
    <div className={`flex items-center justify-between px-2 mb-2 ${className}`}>
      <button onClick={onPreviousClick} disabled={!previousMonth}>
        <ChevronLeftIcon className="size-6 text-info" />
      </button>

      <span className="text-[0.95rem] text-heading font-bold">
        {DateTime.fromJSDate(currentMonth).toFormat("MMMM yyyy")}
      </span>

      <button onClick={onNextClick} disabled={!nextMonth}>
        <ChevronRightIcon className="size-6 text-info " />
      </button>
    </div>
  );
};

export default CustomNav;
